import { getBrightcoveAccountId, getRole } from "./localstorage-service";

export function formatUtcDate(date) {
  let strDate = String(date);
  const stringLength = strDate.length;
  const lastChar = strDate.charAt(stringLength - 1);
  if (lastChar.toLowerCase() !== "z") {
    return strDate + "Z";
  }
  return strDate;
}

export function validateEmail(email) {
  var re = /^(([^<>()[\]\\.,;:\s@]+(\.[^<>()[\]\\.,;:\s@]+)*)|(.+))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(email);
}

export function emptyCheck(value) {
  return value.trim().length === 0;
}

Number.isInteger =
  Number.isInteger ||
  function (value) {
    return typeof value === "number" && isFinite(value) && Math.floor(value) === value;
  };

export function isInt(value) {
  if (isNaN(parseInt(value, 10))) {
    return false;
  } else {
    return Number.isInteger(parseInt(value, 10));
  }
}

export function validatePassword(str) {
  // at least one number, one lowercase and one uppercase letter
  // at least twelve characters
  var re = /(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%^&*]).{12,}/;
  return re.test(str);
}
export function validatePasswordConsecutiveCharacter(str, name) {
  const tempName = name.trim().toLowerCase();
  for (let i = 0; i < tempName.length; i++) {
    if (i + 2 < tempName.length) {
      const tempConsStr = tempName.substring(i, i + 2);
      if (str.toLowerCase().indexOf(tempConsStr) >= 0) {
        return true;
      }
    }
  }
  return false;
}

export function getParameterByName(name, url) {
  if (!url) url = window.location.href;
  name = name.replace(/\]]/g, "\\$&");
  var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
    results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return "";
  return decodeURIComponent(results[2].replace(/\+/g, " "));
}

export function capitalizeFirstLetter(string) {
  if (string) return string.charAt(0).toUpperCase() + string.slice(1);
  else return string;
}

export function showToastMessage(type, title, message, currentInstance, refName) {
  switch (type) {
    case "success":
      currentInstance.refs[refName].success(message, title, {
        closeButton: true,
      });
      break;
    case "error":
      currentInstance.refs[refName].error(message, title, {
        closeButton: true,
      });
      break;
    case "warning":
      currentInstance.refs[refName].warning(message, title, {
        closeButton: true,
      });
      break;
    default:
      break;
  }
}

export function showErrorToastMessage(currentInstance, refName, error) {
  console.log("Error " + error);
  let errorMessage = "";
  if (error.response) {
    console.log("inside error response");
    errorMessage = error.response.data.InnerException
      ? error.response.data.InnerException.InnerException.ExceptionMessage
      : error.response.data.ExceptionMessage;

    errorMessage = error.response.data.Message + " " + errorMessage;
  } else {
    console.log("inside network error");
    if (String(error).toLowerCase().indexOf("network error") >= 0) {
      errorMessage = "Network Error. Contact IT Administrator";
    }
  }
  showToastMessage("error", "Error", errorMessage, currentInstance, refName);
}
export function appendBrightcoveScript() {
  const script = document.createElement("script");
  script.src = `https://players.brightcove.net/${getBrightcoveAccountId()}/default_default/index.min.js`;
  script.async = true;
  document.body.appendChild(script);
}
// export function initBrightCovePlayer() {
//   let myPlayer;
//   let videojs = window.videojs;
//   let rateValue;
//   myPlayer = videojs("video-player");
//   var options = { playbackRates: [0.5, 1, 2] };
//   if (Array.isArray(options.playbackRates)) {
//     myPlayer.options_.sourceOrder = false;
//     if (myPlayer.controlBar.playbackRateMenuButton) {
//       var playbackControl = myPlayer.controlBar.playbackRateMenuButton;
//       playbackControl.removeChild(playbackControl.menu);
//       playbackControl.options_.playbackRates = options.playbackRates;
//       playbackControl.addChild(playbackControl.createMenu());
//       playbackControl.updateLabel();
//       playbackControl.updateVisibility();
//     } else {
//       myPlayer.controlBar.playbackRateMenuButton = myPlayer.controlBar.addChild("PlaybackRateMenuButton", {
//         playbackRates: options.playbackRates
//       });
//       myPlayer.controlBar.playbackRateMenuButton.updateVisibility();
//     }
//   }

//   if (videojs.browser.IE_VERSION) {
//     console.log("IE_VERSION");
//     function getPlayBackRate() {
//       var rateEl = document.getElementsByClassName("vjs-playback-rate-value")[0];
//       rateValue = rateEl.innerText.substr(0, rateEl.innerText.length - 1);
//       return rateValue;
//     }
//     myPlayer.on("pause", function() {
//       rateValue = getPlayBackRate();
//     });
//     myPlayer.on("ratechange", function() {
//       if (myPlayer.paused()) {
//         rateValue = getPlayBackRate();
//       }
//     });
//     myPlayer.on("play", function() {
//       myPlayer.playbackRate(rateValue);
//     });
//   }
// }

export function showSuccessToastMessage(currentInstance, refName, action, item, type) {
  let title = "";
  let message = "";
  switch (action) {
    case "edit": {
      title = "Success";
      message = `${type}: ${item} updated successfully!`;
      break;
    }
    case "add": {
      title = "Success";
      message = `${type}: ${item} created successfully!`;
      break;
    }
    case "delete": {
      title = "Success";
      message = `${type}: ${item} deleted successfully!`;
      break;
    }
    default:
      break;
  }
  showToastMessage("success", title, message, currentInstance, refName);
}

function verifyRole(name) {
  const rolesArr = getRole().toLocaleLowerCase().split(",");
  let isInRole = false;
  for (const role of rolesArr) {
    if (role === name) {
      isInRole = true;
      break;
    }
  }
  return isInRole;
}

export function isAdmin() {
  return verifyRole("admin");
}

export function isSuperAdmin() {
  return verifyRole("super admin");
}



// WEBPACK FOOTER //
// ./src/utilities.js